import React from 'react'
import './css/Blogs.css'


const Blogs = () => {
    return (
       
        <div className="row">
            <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="500">
                <div className="card tabCards">
                    <div className="card-body">
                        <h5 className="card-title blueTxt">Fundraising</h5>
                        <p className="card-text">Your Absolute Guide to Nonprofit Fundraising Success</p>
                        <a href="/blog/nonprofit-fundraising" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="500">
                <div className="card tabCards">
                    <div className="card-body">
                        <h5 className="card-title blueTxt">Donor Management</h5>
                        <p className="card-text">Mastering Donor Management for Nonprofits using Cloud-based CRM System.</p>
                        <a href="/blog/donor-management-for-nonprofits" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                    </div>
                </div>
            </div>
        </div>
       
    )
}

export default Blogs